export enum EntityType {
    CLIENT_RECORD = 'CLIENT_RECORD',
    ORGANIZATION = 'ORGANIZATION',
    PRODUCT_PROCESS = 'PRODUCT_PROCESS',
    CLIENT_QUALITY_MANUAL = 'CLIENT_QUALITY_MANUAL',
    WAREHOUSE = 'WAREHOUSE',
}
